// @flow

import * as React from 'react';
import RippleButton from './RippleButton';

type Props = {
  icon?: ?string,
  text?: ?string,
  className?: string,
  onClick: Function,
  disableRippleOnClick?: boolean,
  isLoading?: ?boolean,
  children?: ?React.Node,
  disabled?: boolean,
  title?: string,
}

class IconButton extends React.PureComponent<Props> {
  static defaultProps = {
    className: '',
    disableRippleOnClick: false,
    text: null,
    icon: null,
    isLoading: false,
    children: null,
    disabled: false,
  };

  getIconOrText = () => {
    if (this.props.icon) {
      return (
        <i className={`${this.props.icon} icon`} />
      );
    }
    return (
      <span>
        {this.props.text}
      </span>
    );
  };

  render() {
    return (
      <RippleButton
        onClick={this.props.onClick}
        className={`rounded-button ${this.props.className || ''}`}
        disableRippleOnClick={this.props.disableRippleOnClick}
        disabled={this.props.disabled || this.props.isLoading}
        title={this.props.title}
      >
        {
          this.props.isLoading
            ? (
              <i className="fa fa-spinner fa-spin" />
            ) : (
              <React.Fragment>
                {this.getIconOrText()}
                {this.props.children}
              </React.Fragment>
            )
        }
      </RippleButton>
    );
  }
}

export default IconButton;
